<template>
<div class="range-feature-field">
  <div class="range-feature-field__inputs">
    <input
      type="number"
      v-model.number="fromAccessor"
      :min="min"
      :placeholder="min"
      :step="interval"
      class="range-feature-field__input form-control"
    >
    <span class="range-feature-field__input-dash">–</span>
    <input
      type="number"
      v-model.number="toAccessor"
      :max="max"
      :placeholder="max"
      :step="interval"
      class="range-feature-field__input form-control"
    >
  </div>
  <VueSlider
    v-model="sliderAccessor"
    :max="max"
    :min="min"
    :min-range="(max - min) / 100"
    :interval="interval"
    tooltip="none"
    :contained="true"
    :duration="0.15"
    :dot-style="{
      'border-color': 'var(--_color-primary)',
      'border-width': '4px',
      'box-shadow': 'unset', // Setting our theme's color instead would be nice.
    }"
    :process-style="{ 'background-color': 'var(--_color-primary)' }"
    :rail-style="{ 'background-color': 'var(--_color-primary-lighter)' }"
    class="range-feature-field__slider"
  />
</div>
</template>

<script>
import AbstractFeatureField from './AbstractFeatureField'
import VueSlider from 'vue-slider-component'

function transformInputVal(v) {
  return v === ''
    ? null
    : v;
}

export default AbstractFeatureField.extend({
  components: {
    VueSlider,
  },
  props: {
    value: {
      required: true,
      validator(v) {
        return [v.to, v.from].every(v => v === null || typeof v === 'number');
      },
    },
  },
  computed: {
    fromAccessor: {
      get() { return this.value.from; },
      set(v) { this.valueAccessor.from = transformInputVal(v); },
    },
    toAccessor: {
      get() { return this.value.to; },
      set(v) { this.valueAccessor.to = transformInputVal(v); },
    },
    sliderAccessor: {
      get() {
        return [
          this.valueAccessor.from || this.min,
          this.valueAccessor.to || this.max
        ];
      },
      set([from, to]) { this.valueAccessor.from = from; this.valueAccessor.to = to; },
    },
    max() {
      return this.maxOrMin('max');
    },
    min() {
      return this.maxOrMin('min');
    },
    interval() {
      if (this.feature.range_type.id === 'integer') {
        return 1;
      }
      // This value is only chosen because this component is used for prices. It may not be suitable for all features.
      // TODO.
      return 0.01;
    }
  },
  methods: {
    /**
     * @param {'max' | 'min'} maxOrMin
     */
    maxOrMin(maxOrMin) {
      return Math[maxOrMin](...this.feature.values.map(v => v.range_value));
    },
  },
})
</script>

<style lang="less">
@import '~vue-slider-component/theme/antd.css';

.range-feature-field {
  --_color-primary: theme('colors.primary');
  --_color-primary-lighter: theme('colors.primary-lighter');
  &__inputs {
    @apply flex items-center;
  }
  &__input {
    @apply flex-grow w-0;
  }
  &__input-dash {
    @apply flex-grow-0 text-xl text-dark-lighter;
  }
  &__slider {
    @apply mt-2;
  }
}
</style>
